<template>
  <Layout>
    <section class="csms-settlement-report">

      <!-- Page Title Start -->
      <PageHeader :title="title" />
      <!-- Page Title End -->

      <!-- Search Area Start -->
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">

                <!-- // Search Input -->
                <div class="col-xl-10 ion-mb-mb-100">
                  <div class="row">
                    <div class="col-xl-3">
                      <label class="form-label" for="settlement-report-search-cp">{{ $t('settlement.roleCP') }}</label>
                      <multiselect id="settlement-report-search-cp"
                                   label="text" track-by="value"
                                   v-model="searchForm.cp"
                                   :options="cpOptions"
                                   selectLabel=""
                                   selectedLabel=""
                                   deselectLabel=""
                                   :searchable="false" :allow-empty="false" />
                    </div>
                    <div class="col-xl-3">
                      <label class="form-label" for="settlement-report-search-title">{{ $t('settlement.title') }}</label>
                      <b-form-input class="form-control" type="text" id="settlement-report-search-title"
                                    v-model="searchForm.title" />
                    </div>
                  </div>
                </div>

                <!-- // Search Button -->
                <div class="col-xl-2 align-content-end">
                  <div class="float-end">
                    <b-button variant="secondary" class="me-3" @click="reset">
                      <i class="uil uil-redo me-2"></i>
                      <span>{{ $t('btn.reset') }}</span>
                    </b-button>
                    <b-button variant="primary" @click="search">
                      <i class="uil uil-search me-2"></i>
                      <span>{{ $t('btn.search') }}</span>
                    </b-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Search Area End -->

      <!-- List Start -->
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">

              <div class="row mb-3 align-items-end">
                <!-- // List PerPage Count -->
                <div class="col-auto">
                  <PerPageSelector v-model="pagination.perPage"
                                   :option="[50, 100, 200]"
                                   @change="onPerPageChange" />
                </div>
                <!-- // Total Count -->
                <div class="col me-2">
                  <div class="float-end">
                    <total-count :total-count="pagination.totalCount" />
                  </div>
                </div>
              </div>

              <!-- // List -->
              <div class="table-responsive">
                <b-table class="text-nowrap align-middle" bordered hover
                         show-empty :empty-text="$t('settlement.noReport')"
                         :fields="fields" :items="items">
                  <template #head()="data">
                    <span v-if="!$_utils.isEmpty(data.label)">{{ $t(`settlement.${data.column}`) }}</span>
                  </template>

                  <template #cell(cpName)="data">
                    {{ data.item.chargePlace.placeName }}
                  </template>

                  <template #cell(etc)="data">
                    <button v-if="$_app.user.roles[0] === 'ADMIN' || $_app.user.roles[0] === 'HQ'"
                            class="btn btn-sm btn-danger me-4"
                            @click="del(data.item.id)">
                      <i class="uil uil-minus me-2"></i>
                      <span>{{ $t('btn.delete') }}</span>
                    </button>

                    <button class="btn btn-sm btn-outline-info"
                            @click="downloadFile(data.item.reportFile.fileId, data.item.reportFile.orgName)">
                      <i class="uil uil-download-alt me-2"></i>
                      <span>{{ $t('btn.pdfDownload') }}</span>
                    </button>
                  </template>
                </b-table>
              </div>

              <!-- // Pagination -->
              <div class="row mt-3">
                <div class="col-xl-12">
                  <b-pagination size="sm" class="mb-0" align="center"
                                :total-rows="pagination.totalCount"
                                :per-page="pagination.perPage"
                                v-model="pagination.currentPage"
                                @change="onPageChange" />
                </div>
              </div>

              <!-- Bottom Button Start -->
              <div class="row" v-if="$_app.user.roles[0] === 'ADMIN' || $_app.user.roles[0] === 'HQ'">
                <div class="col-xl-12">
                  <div class="float-end">
                    <b-button variant="success" @click="create">
                      <i class="uil uil-plus me-2"></i>
                      <span>{{ $t('btn.create') }}</span>
                    </b-button>
                  </div>
                </div>
              </div>
              <!-- Bottom Button End -->

            </div>
          </div>
        </div>
      </div>
      <!-- List End -->

      <create-modal ref="reportCreateModal" @callback="getItems" />
    </section>
  </Layout>
</template>

<script>
import { http } from '@/auth-api';
import { loadingMethods } from '@/state/helpers';
import i18n from '@/i18n';
import Swal from 'sweetalert2';
import Multiselect from 'vue-multiselect';
import Layout from '@/views/layouts/Main.vue';
import PageHeader from '@/components/PageHeader.vue';
import PerPageSelector from '@/views/components/PerPageSelector.vue';
import TotalCount from '@/views/components/TotalCount.vue';
import CreateModal from '@/views/pages/settlement/ReportCreateModal.vue';


export default {
  components: {
    Multiselect, Layout, PageHeader, PerPageSelector, TotalCount, CreateModal
  },
  data() {
    return {
      title: 'settlementReport',
      cpOptions: [],
      searchConditions: [],
      sortDirection: 'DESC',
      pagination: {
        currentPage: 1,
        totalCount : 0,
        perPage: 50
      },
      searchForm: {
        cp: {text: i18n.t('common.total'), value: null},
        title: null,
      },
      fields: [
        { key: 'rnum', label: 'No.', class: 'text-center column-w-8' },
        { key: 'title', label: '제목', class: 'text-center' },
        { key: 'cpName', label: '충전 스탠드', class: 'text-center' },
        { key: 'created', label: '등록일', class: 'text-center column-w-20' },
        { key: 'etc', label: '', class: 'text-center column-w-20' },
      ],
      items: null
    }
  },
  mounted() {
    const vm = this;

    vm.getCpOptions();
    vm.getItems();
  },
  methods: {
    ...loadingMethods,
    getCpOptions() {
      const vm = this;
      const _url = '/onmapi/view/ChargePlace/list';

      vm.cpOptions = [{ text: i18n.t('common.total'), value: null }];

      http.post(_url, {
        page: 1,
        limit: 1000,
        searchConditions: [],
        sortCondition: { sortDirection: 'DESC' }
      }).then(res => {
        res.data.items.forEach(item => {
          vm.cpOptions.push({ text: item.placeName, value: item.placeId });
        });
      }).catch(err => {
        console.error('Charge Place List Error :: ', err)
      })
    },
    async getItems() {
      const vm = this;
      const _url = '/onmapi/view/Settlement/report/list';

      vm.showOverlay();

      await http.post(_url, {
        page: vm.pagination.currentPage,
        limit: vm.pagination.perPage,
        searchConditions: vm.searchConditions,
        sortCondition: { sortDirection: vm.sortDirection }
      }).then(res => {
        vm.items = res.data.items;
        vm.pagination.totalCount = res.data.totalCount;
      }).catch(err => {
        console.error('Settlement Report List Error :: ', err)
      }).finally(() => {
        vm.hideOverlay();
      });
    },
    async reset() {
      const vm = this;

      vm.searchForm = {
        cp: { text: i18n.t('common.total'), value: null },
        title: null,
      };
      vm.searchConditions = [];

      await vm.getItems();
    },
    async search() {
      const vm = this;

      vm.searchConditions = [];

      if (!this.$_utils.isEmpty(vm.searchForm.cp.value)) {
        vm.searchConditions.push({ searchKey: 'placeId', searchValue: vm.searchForm.cp.value });
      }

      if (!this.$_utils.isEmpty(vm.searchForm.title)) {
        vm.searchConditions.push({ searchKey: 'title', searchValue: vm.searchForm.title });
      }

      vm.pagination.currentPage = 1;
      await vm.getItems();
    },
    async onPerPageChange() {
      const vm = this;

      if (vm.pagination.totalCount > 1) {
        vm.pagination.currentPage = 1;
        await vm.getItems();
      }
    },
    async onPageChange(val) {
      const vm = this;
      vm.pagination.currentPage = val;

      if (vm.pagination.totalCount > 1) {
        await vm.getItems();
      }
    },
    async downloadFile(fileId, fileName) {
      const vm = this;

      try {
        vm.showOverlay();

        const response = await http.get(`/onmapi/view/File/download/${fileId}`, {
          responseType: 'blob'
        });

        // Blob URL 생성
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);

        // 임시 a 태그 생성하여 다운로드
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('File download Error: ', error);
        await Swal.fire({
          icon: 'error',
          title: i18n.t('alert.downloadFailed'),
          showConfirmButton: false,
          timer: 3000,
        });
      } finally {
        vm.hideOverlay();
      }
    },
    create() {
      const vm = this;

      vm.$nextTick(() => {
        this.$refs.reportCreateModal.show();
      });
    },
    del(id) {
      const vm = this;

      Swal.fire({
        title: i18n.t('alert.confirmDelete'),
        showCancelButton: true,
        confirmButtonText: i18n.t('btn.ok'),
        cancelButtonText: i18n.t('btn.cancel')
      }).then((result) => {
        if (result.isConfirmed) {
          (async () => {
            let _url = `/onmapi/view/Settlement/report/delete/${id}`;

            try {
              await http.delete(_url);
              console.info('Settlement Report Delete Success !!', id);
            } catch (err) {
              console.error('Settlement Report Delete Error !!', err);
            }

            await vm.getItems();

            await Swal.fire({
              icon: 'info',
              title: i18n.t('alert.deleted'),
              confirmButtonText: i18n.t('btn.close')
            });
          })();
        }
      })
    }
  }
}
</script>

<style src='vue-multiselect/dist/vue-multiselect.min.css'></style>
